// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"17a9729c","140":"9a88eb50","220":"588871af","238":"539f0348","376":"e14b2600","417":"63ff9418","453":"e2f1ec05","527":"f3f89b53","760":"51fb005e","840":"1466de3d","970":"648c333d"}[chunkId] + ".chunk.js";
};